export default __webpack_public_path__ + "static/intergations-presentation-by-abf899635bcac0ae9742af39c8d55ba3.png";